<script lang="ts">
	import { onDestroy, SvelteComponent } from "svelte";
	import { storeCurRoute, routes } from "../scripts/router1";

	let component: typeof SvelteComponent;
	export let anchor: string = "";

	const unsubscribe = storeCurRoute.subscribe((routeId) => {
		const route = routes.filter((r) => r.id === routeId)[0];
		component = route.component;
		if (route.anchor != "") {
			anchor = route.anchor;
		} else {
			anchor = "";
		}
	});

	onDestroy(unsubscribe);
</script>

<style lang="scss">
	.route {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		min-height: $route-height;
	}
</style>

<div class="route">
	{#if anchor != ""}
		{#key anchor}
			<svelte:component this={component} {anchor} />
		{/key}
	{:else}
		<svelte:component this={component} />
	{/if}
</div>
